import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBrowserSupport, deviceInfo } from "../util/browserSupport";
import { BROWSER_SUPPORT } from "../enums/browser-enums";
import { ERROR_ROUTE_SUBPATHS, getFullRoutePath } from "../../routing/ErrorRoutes";
import { logger } from "../util/logger";

/**
 * Hook that handles browser support detection:
 * - Detects browser support level on mount
 * - Redirects to unsupported browser page if needed
 * - Logs device info for debugging
 *
 * @returns { browserStatus } - The current browser support status
 */
export const useBrowserDetection = () => {
  const navigate = useNavigate();
  const [browserStatus, setBrowserStatus] = useState<BROWSER_SUPPORT>();

  useEffect(() => {
    const _browserStatus = getBrowserSupport();
    setBrowserStatus(_browserStatus);
    if (_browserStatus === BROWSER_SUPPORT.UNSUPPORTED) {
      navigate(getFullRoutePath(ERROR_ROUTE_SUBPATHS.UNSUPPORTED_BROWSER));
    }
    logger.info("device", deviceInfo);
  }, [navigate]);

  return { browserStatus };
};
